import { FC } from 'react'
import { useIntl } from 'react-intl'

import { Descriptions, Tabs } from 'antd'

import { Description } from './Description'

function calculateWinRate(wins: number, total: number): number {
  return Math.round((wins / total) * 100)
}

function getCountByCategory(categories: MotoGP.StatsCategories, name: string): number {
  return categories.find((it) => it.category.name === name)?.count || 0
}

const Achievements: FC<{ data: MotoGP.RiderStats }> = ({ data }) => {
  const { formatMessage } = useIntl()
  const categories: Record<string, MotoGP.StatsCategories> = data?.all_races?.categories
    ?.map((it) => it.category.name)
    .reduce((acc, it) => ({ ...acc, [it]: it }), {})
  if (!categories) return null

  return (
    <Description titleId={'rider.achievements'}>
      <Tabs
        items={Object.keys(categories).map((it) => {
          const allRaces = getCountByCategory(data.all_races.categories, it)
          const podiums = getCountByCategory(data.podiums.categories, it)
          const poles = getCountByCategory(data.poles.categories, it)
          const firstPositions = getCountByCategory(data.grand_prix_victories.categories, it)
          const secondPositions = getCountByCategory(data.second_positions.categories, it)
          const thirdPositions = getCountByCategory(data.third_positions.categories, it)
          const championships = getCountByCategory(data.world_championship_wins.categories, it)
          const fastestLaps = getCountByCategory(data.race_fastest_laps.categories, it)
          return {
            key: it,
            label: it,
            children: (
              <Descriptions
                size={'small'}
                layout={'horizontal'}
                column={1}
                items={[
                  {
                    label: formatMessage({ id: 'rider.stats.total-races' }),
                    children: allRaces,
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.podiums' }),
                    children: [podiums, `(${calculateWinRate(podiums, allRaces)}%)`].join(' '),
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.poles' }),
                    children: [poles, `(${calculateWinRate(poles, allRaces)}%)`].join(' '),
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.fastest-laps' }),
                    children: [fastestLaps, `(${calculateWinRate(fastestLaps, allRaces)}%)`].join(' '),
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.gran-prix-1st' }),
                    children: [firstPositions, `(${calculateWinRate(firstPositions, allRaces)}%)`].join(' '),
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.gran-prix-2nd' }),
                    children: [secondPositions, `(${calculateWinRate(secondPositions, allRaces)}%)`].join(' '),
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.gran-prix-3rd' }),
                    children: [thirdPositions, `(${calculateWinRate(thirdPositions, allRaces)}%)`].join(' '),
                  },
                  {
                    label: formatMessage({ id: 'rider.stats.world-championships' }),
                    children: championships,
                  },
                ]}
              />
            ),
          }
        })}
      />
    </Description>
  )
}

export { Achievements }
